module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/2-3-7e7944b5743d3c01885c7771da4d07b7.jpg";